import { AlkLogger } from '@alk/core';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { inject, injectable } from 'inversify';
import { INotificationsAdapter, NOTIFICATIONS_ADAPTER_SERVICE } from '../../message-adapters/notifications-adapter';
import { INotificationsService } from './notifications.interface';
import {
    ISessionDisposable,
    NotificationItemsListTransaction,
} from '../../../interfaces';
import { Observable, Subject } from 'rxjs';
import { transformNotificationTransaction } from './notifications.service.utils';

@injectable()
export class NotificationsService implements INotificationsService, ISessionDisposable {

    @inject(NOTIFICATIONS_ADAPTER_SERVICE) private readonly notificationsAdapterService: INotificationsAdapter;

    private originalNotificationsSource$: Observable<NotificationItemsListTransaction>;

    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    private createNotificationsSource(): Observable<NotificationItemsListTransaction> {

        AlkLogger.debug('[NotificationsService#createNotificationsSource] service is about to start');

        return this.notificationsAdapterService.notificationsObservable()
            .pipe(
                map(transformNotificationTransaction),
                takeUntil(this.destroy$),
                finalize(() => this.originalNotificationsSource$ = null),
            );
    }

    stop(): void {

        AlkLogger.debug('[NotificationsService#createNotificationsSource] service is about to stop');

        this.destroy$.next(true);

        this.originalNotificationsSource$ = null;
    }

    notificationTransactionsObservable(): Observable<NotificationItemsListTransaction> {

        this.originalNotificationsSource$ = this.originalNotificationsSource$ ?? this.createNotificationsSource();

        return this.originalNotificationsSource$;
    }

}
